import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';

const CUET_TopicModal = forwardRef((props, ref) => {
    const initialData = {
        Sn: 0,
        ExamType: 'Section-IA',
        SubjectType: 'Select Subject Type',
        SubjectTypeID: 0,
        Section: 'Select Section',
        SectionID: 0,
        Topic: 'N/A',
        NoOfQuestion: 0,
        AvailableQuestions: 0,
        assignedQuestions: 0
    };

    const [modalBox, setModalBox] = useState(false);
    const [examBodyData, setExamBodyData] = useState(initialData);
    console.log(examBodyData);
    const [subjects, setSubjects] = useState([]);
    const [sections, setSections] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState(null);
    const [selectedSections, setSelectedSections] = useState(null);


    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            console.log(item);
            if (item?.Sn > 0) {
                setExamBodyData(item);
                setSelectedSubjects(subjects.filter((subject) => subject.ExamType === item.ExamType));
                setSelectedSections(sections.filter((section) => section.SubjectTypeID === item.SubjectTypeID));
            } else {
                const newData = { ...initialData, ...item };
                setExamBodyData(newData);
                if (newData.ExamType) {
                    setSelectedSubjects(subjects.filter((subject) => subject.ExamType === newData.ExamType));
                }
                if (newData.SubjectTypeID) {
                    setSelectedSections(sections.filter((section) => section.SubjectTypeID === newData.SubjectTypeID));
                }
            }
            setModalBox(true);
        }
    }));
    useEffect(() => {
        const response = axios.all([
            axios.get(BACKEND_SERVER_URL + '/cuet/subjects'),
            axios.get(BACKEND_SERVER_URL + '/cuet/sections')
        ]);
        response.then(axios.spread((subjectsResponse, sectionsResponse) => {
            let subjects = subjectsResponse.data.subjects;
            let sections = sectionsResponse.data.sections;
            setSubjects(subjects);
            setSections(sections);
        })).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects and sections.");
        });
        return () => {
            setSubjects([]);
            setSections([]);
            setSelectedSubjects(null);
            setSelectedSections(null);
            setExamBodyData(initialData);
            // setModalBox(false);
        };

    }, [])

    const handleSaveTopic = async () => {
        try {
            if (!examBodyData.SubjectType || examBodyData.SubjectType.trim() === '' || examBodyData.SubjectType === 'Select Subject Type') {
                toast.error("Please enter subject name");
                return;
            }

            if (!examBodyData.ExamType || examBodyData.ExamType.trim() === '') {
                toast.error("Please select subject type");
                return;
            }

            if (!examBodyData.SectionID) {
                toast.error("Please select section");
                return;
            }

            if (!examBodyData.Topic || examBodyData.Topic.trim() === '') {
                toast.error("Please enter topic");
                return;
            }

            const response = await axios.post(
                `${BACKEND_SERVER_URL}${examBodyData.Sn ? '/cuet/updateTopic' : '/cuet/createTopic'}`,
                examBodyData
            );

            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);
            setModalBox(false);
            setExamBodyData(initialData);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };
    // useEffect(() => {
    //     if (!examBodyData.SubjectTypeID || !examBodyData.SectionID) {
    //         return;
    //     }
    //     try {
    //         axios.get(`${BACKEND_SERVER_URL}/cuet/available-quetions/${examBodyData.ExamType}/${examBodyData.SubjectTypeID}/${examBodyData.SectionID}/${examBodyData.Sn}`)
    //             .then((response) => {
    //                 const availableQuestions = response.data.availableQuestions || 0;
    //                 setExamBodyData((prevData) => ({
    //                     ...prevData,
    //                     AvailableQuestions: availableQuestions,/* 
    //                     NoOfQuestion: Math.min(prevData.NoOfQuestion, availableQuestions) */ // Ensure NoOfQuestion does not exceed AvailableQuestions
    //                 }));
    //             })

    //     } catch (error) {
    //         console.error("Error fetching available questions:", error);
    //         return 0;

    //     }
    // }, [examBodyData.SubjectTypeID, examBodyData.SectionID, examBodyData.ExamType]);

    // useEffect(() => {
    //     if (!examBodyData.SubjectTypeID || !examBodyData.ExamType || !modalBox /*  || !examBodyData.SectionID */) {
    //         return;
    //     }
    //     try {
    //         axios.get(`${BACKEND_SERVER_URL}/cuet/assigned-quetions/${examBodyData.ExamType}/${examBodyData.SubjectTypeID}`)
    //             .then((response) => {
    //                 const assignedQuestions = response.data.assignedQuestions || 0;
    //                 console.log(assignedQuestions);
    //                 setExamBodyData((prevData) => ({
    //                     ...prevData,
    //                     assignedQuestions: assignedQuestions,
    //                 }));
    //             })

    //     } catch (error) {
    //         console.error("Error fetching available questions:", error);
    //         return 0;

    //     }
    // }, [examBodyData.SubjectTypeID, examBodyData.ExamType, modalBox]);

    return (
        <Modal
            onHide={() => setModalBox(false)}
            show={modalBox}
            size="lg"
            backdrop="static"
            keyboard={false}
        >
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                        {examBodyData.Sn ? "Update SUB TOPIC" : "Add SUB TOPIC"}
                    </h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>

                <div className="modal-body pb-0">
                    {/* <div className="d-flex w-100 justify-content-end mt-0 pt-0">
                        <span className={`p-1 px-3 fw-bold text-white ${examBodyData.assignedQuestions==50?'bg-success':'bg-danger'} fs-4 border border-2 rounded`}>Total Questions : {examBodyData.assignedQuestions}</span>
                    </div> */}

                    <div className="d-flex w-100 justify-content-around mb-3">
                        <div className="mb-3  col-5">
                            <label className="form-label text-primary">All SUBJECT<span className="required">*</span></label>
                            <Select
                                value={(() => {
                                    const options = [
                                        { value: 'Section-IA', label: 'Language Subjects' },
                                        { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                        { value: 'Section-III', label: 'General Aptitude Test' }
                                    ];
                                    return options.find(opt => opt.value === examBodyData.ExamType) || { value: examBodyData.ExamType, label: examBodyData.ExamType };
                                })()}
                                onChange={(option) => {
                                    console.log(option.value);
                                    setExamBodyData((preValue) => ({ ...preValue, ExamType: option.value }));
                                    setSelectedSubjects(subjects.filter((subject) => subject.ExamType === option.value));
                                    setSelectedSections([]); // Reset sections when exam type changes
                                    setExamBodyData((preValue) => ({ ...preValue, SubjectType: 'Select Subject Type', Section: 'Select Section', SubjectTypeID: 0, SectionID: 0 }));
                                }

                                }
                                options={[
                                    { value: 'Section-IA', label: 'Language Subjects' },
                                    { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                    { value: 'Section-III', label: 'General Aptitude Test' }
                                ]}
                                styles={{ control: (base) => ({ ...base, borderColor: '#17a2b8' }) }}
                            />
                        </div>
                        <div className="mb-3 col-5">
                            <label className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.SubjectType, label: examBodyData.SubjectType }}
                                onChange={(option) => {
                                    setExamBodyData({ ...examBodyData, SubjectType: option.value.SubjectType, SubjectTypeID: option.value.Sn });
                                    setSelectedSections(sections.filter((section) => section.SubjectTypeID === option.value.Sn));
                                }}
                                options={selectedSubjects?.map((course) => ({ value: course, label: course.SubjectType }))}
                                styles={{ control: (base) => ({ ...base, borderColor: '#17a2b8' }) }}
                            />
                        </div>


                    </div>
                    <div className="d-flex w-100 justify-content-around mb-3">
                        <div className="mb-3  col-5">
                            <label className="form-label text-primary">TOPICS<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Section, label: examBodyData.Section }}
                                onChange={(option) =>
                                    setExamBodyData({ ...examBodyData, Section: option.value.Section, SectionID: option.value.Sn })
                                }
                                options={selectedSections?.map((course) => ({ value: course, label: course.Section }))}
                                styles={{ control: (base) => ({ ...base, borderColor: '#17a2b8' }) }}
                            />
                        </div>
                        <div className="mb-3 col-5">
                            <label className="form-label text-primary">SUB TOPIC<span className="required">*</span></label>
                            <input
                                className="form-control"
                                type="text"
                                value={examBodyData.Topic}
                                onChange={(e) => setExamBodyData({ ...examBodyData, Topic: e.target.value })}
                            />
                        </div>
                    </div>
                    {/* <div className="d-flex w-100 justify-content-around mb-3">
                        <div className="mb-3 col-5">
                            <label className="form-label text-primary">Number of Questions</label>
                            <input
                                disabled={examBodyData.AvailableQuestions <= 0}
                                className="form-control"
                                type="number"
                                value={examBodyData.NoOfQuestion}
                                onChange={(e) =>
                                    setExamBodyData({
                                        ...examBodyData,
                                        NoOfQuestion: parseInt(e.target.value || 0)
                                    })
                                }
                            />
                        </div>
                        <div className="mb-3 col-5">
                            <label className="form-label text-primary">Available Questions</label>
                            <input
                                className="form-control"
                                type="number"
                                value={examBodyData.AvailableQuestions}
                                disabled
                            />
                        </div>
                    </div> */}
                </div>

                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs" onClick={handleSaveTopic}>
                        {examBodyData.Sn ? "Update SUB TOPIC" : "Add SUB TOPIC"}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default CUET_TopicModal;
